import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import { ICheckBox } from './types';

export default function CheckboxWrapper(props: ICheckBox) {
  return (
    <FormControlLabel control={<Checkbox  {...props} />} label={props.label || ''} />
  );
}